import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import { batch, useSelector } from 'react-redux'
import { UpdateClassBookingService, UpdatePersonalTrainingSubscriptionTeacherService } from '../../services/class_booking/classBookingServices'
import BatchBookingMenu from './BatchBookingMenu'
import { GetClassRoomService } from '../../services/admin/ClassRoomServices'
function BatchBookingCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const {state} = useLocation()
  const user = useSelector(state=>state.Auth)
  const isTeacher = user?.logged_user_type === 'Teacher'

  console.log("state",state)
  
  const [data, setdata] = useState({teacher: '', batch: '', class: '', students: [],meet_link:'',remarks:''});
  const [error, seterror] = useState({teacher: '', batch: '', class: '', students: '',meet_link:'',remarks:''});

  const [student,setstudent] = useState([])
  const [classRoom,setClassRoom] = useState([])

  const navigate = useNavigate();
  const studentLabel = (s) => isTeacher ? s?.name ?? 'No Name Added' : `${s?.name ?? 'No Name Added'} - [${s?.mobile}]`

  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {

      let d = state 

      let passData = {
        ...d,
        teacher:{label:d?.teacher?.name,value:d?.teacher?._id},
        students:d?.students?.length > 0 ? d?.students?.map((s)=>({label:studentLabel(s),value:s?._id})) : [],
        batch:{label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id},
        class: d?.class?._id ? {label:d?.class?.standard,value:d?.class?._id} : '',
        class_room: d?.class_room?._id ? {label:`${d?.class_room?.label}[${d?.class_room?.name}]`,value:d?.class_room?._id} : ''
      }
      setstudent(passData?.student)

      setdata(passData)
    
    }

  }, [state])

  async function getClassRoom(){
    const response = await GetClassRoomService(1,'','','')
    if(response?.status === 200){
      let arr = []
      response?.data?.datas?.forEach((item)=>{
        arr?.push({label:item?.label,value:item?._id})
      })
      setClassRoom(arr)
    }

  }



  async function handlechange(e) {
    let {name,value} = e.target
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }



  async function submitform() {
    if (!data.meet_link) {
      seterror({ ...error, meet_link: 'This field is required *' })
    }else {
        let sendData = { ...data }
        sendData['batch'] = data?.batch?.value
        sendData['class'] = data?.class?.value
        sendData['teacher'] = data?.teacher?.value
        sendData['students'] = data?.students?.map((s)=>s?.value)
   
        sendData["id"] = state?._id
        const response = await UpdatePersonalTrainingSubscriptionTeacherService(sendData)
        if (response.status === 200) {
          navigate(-1)
          toast.success('Batch Booking Info Updated Successfully')
        }
      }
  }



  async function handleSelect(e,e1){
    if(e1 === 'student'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(student?.find((r)=>r?.value === ele))
      })
      setdata({...data,students:arr})
      seterror({...error,students:''})
    }

    if(e1 === 'class_room'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(classRoom?.find((r)=>r?.value === ele))
      })
      setdata({...data,class_room:arr})
      seterror({...error,class_room:''})
    }
  }

   const formatTo12Hour = (time) => {
      if (!time) return "";

      const [hours, minutes] = time.split(":");
      let h = parseInt(hours, 10);
      const ampm = h >= 12 ? "PM" : "AM";

      h = h % 12 || 12; // convert 0 -> 12
      return `${h}:${minutes} ${ampm}`;
  };
 
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
      <BatchBookingMenu />
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full relative lg:w-[300px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Teacher Batch Booking Slot Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Teacher Batch Booking Slot details</b> assign to you!.</h6>



          {(state?._id !== undefined) && (state?.mode === 'online') &&
          <div className='relative'>
          {state?.meet_link && <h6 onClick={() => {
            const separator = state?.meet_link?.includes("?") ? "&" : "?";
            window?.open(`myacademy://join?room=${state?.meet_link}&role=teacher`)}}
            className='text-[14px] text-green-600 font-[600] text-[9px] cursor-pointer absolute right-0 top-1 underline underline'>Open Meet</h6>}
          <TextInput
            mandatory={true}
            label={'Meet Link'}
            variant="standard"
            name="meet_link"
            type="text"
            // readOnly={(roles?.includes('admin') || state?._id == undefined)}
            error={error.meet_link}
            value={data.meet_link}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />
            </div>}  


            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Teacher Info </h6>
                <Select
                  value={data.teacher} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'teacher')} 
                  options={[]} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class </h6>
                <Select
                  value={data.class} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Batch </h6>
                <Select
                  value={data.batch} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Room </h6>
                <Select
                  value={data.class_room} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  mode="multiple"
                  onChange={(e)=>handleSelect(e,'class_room')} 
                  options={classRoom} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 


            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Students </h6>
                <Select
                  value={data.students} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  mode="multiple"
                  onChange={(e)=>handleSelect(e,'student')} 
                  options={student} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 


            
  
  
          <ErrorComponent error={error?.type} /> 

        

          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="remarks"
            type="text"
            error={error.remarks}
            value={data.remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

         
        <div className='mt-4 flex'>
       
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>


        </div>
        
       

      
      </div>

      
      </div> 

    </div>
  )
}

export default BatchBookingCE